var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 192,
  height: 192,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 25.929A3.429 3.429 0 0 1 9.429 22.5H170.57A3.429 3.429 0 0 1 174 25.929V40.5H6V25.929Z",
  fill: "#8A8A8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM154.5 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM165 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 40.5h168v101.571a3.429 3.429 0 0 1-3.429 3.429H9.429A3.429 3.429 0 0 1 6 142.071V40.5Z",
  fill: "#5E5E5E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424242",
  d: "M42 58.5h96v6H42zM42 76.5h96v6H42z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 48.429A3.429 3.429 0 0 1 21.429 45H182.57A3.429 3.429 0 0 1 186 48.429V63H18V48.429Z",
  fill: "#8A8A8A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M156 57a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM166.5 57a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM177 57a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM18 63h168v101.571a3.429 3.429 0 0 1-3.429 3.429H21.429A3.429 3.429 0 0 1 18 164.571V63Z",
  fill: "#5E5E5E"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#424242",
  d: "M54 81h96v6H54zM54 99h96v6H54z"
})));
export { SvgImageLoading as ReactComponent };
export default "/37afca80502c9c21a235b5ceffef5f42.svg";